import gsap from 'gsap';

import { Container, Sprite, Texture } from 'pixi.js';
import { MonoBehavior } from './core/monoBehavior';
import { getAsset } from './preloadGameAssets';
import { Power1 } from 'gsap';
import { Card } from 'components/Card';
import { Layout } from './LayoutManager';

export class MagicGlow extends MonoBehavior {
    glowContainer: Container;

    constructor(card: Card) {
        super();
        this.glowContainer = new Container();
        card.cardDisplay.container.addChild(this.glowContainer);
        this.glowContainer.zIndex = -1;
        this.glowContainer.alpha = 0;
    }
    start(): void {
        this.loadGlow();
    }
    async loadGlow() {
        const cardGlow = await getAsset('MagicWand/cardGlow');
        const txtCardGlow = new Texture(cardGlow);
        const sprite = Sprite.from(txtCardGlow);
        const { width, height } = Layout.getCardSize();
        sprite.width = width * 1.18;
        sprite.height = height * 1.1;
        sprite.anchor.set(0.5);
        this.glowContainer.addChild(sprite);
        this.show();
    }
    show() {
        gsap.to(this.glowContainer, { alpha: 1, duration: 1, delay: 1, ease: Power1.easeOut });
        gsap.to(this.glowContainer, { alpha: 0, duration: 0.3, delay: 2, ease: Power1.easeIn });
    }
}
